import { render, staticRenderFns } from "./LinkDiscord.vue?vue&type=template&id=6abffbf4&scoped=true&"
import script from "./LinkDiscord.vue?vue&type=script&lang=js&"
export * from "./LinkDiscord.vue?vue&type=script&lang=js&"
import style0 from "./LinkDiscord.vue?vue&type=style&index=0&id=6abffbf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abffbf4",
  null
  
)

export default component.exports